import {
  ResponsiveContextProvider,
  ResponsiveDetailCol,
  ResponsiveListCol
} from '@monorepo/common/component/responsive/ResponsiveContextProvider';
import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { Container, Row } from 'reactstrap';
import DisciplineDetail from '../component/discipline/DisciplineDetail';
import DisciplineFilterableList from '../component/discipline/DisciplineFilterableList';

export default function DisciplinesPage() {
  const { path: parentPath, url: parentUrl } = useRouteMatch();
  const path = `${parentPath}/:disciplineId?`;
  const match = useRouteMatch<{ disciplineId?: string }>(path);
  const disciplineId = match?.params.disciplineId;

  return (
    <ResponsiveContextProvider single={false} selectedId={disciplineId}>
      <Route path={path}>
        <Container>
          <Row>
            <ResponsiveListCol>
              <div className="position-fixed-scrollable">
                <DisciplineFilterableList disciplineId={disciplineId} url={parentUrl} />
              </div>
            </ResponsiveListCol>

            <ResponsiveDetailCol>
              <DisciplineDetail disciplineId={disciplineId} listUrl={parentUrl} />
            </ResponsiveDetailCol>
          </Row>
        </Container>
      </Route>
    </ResponsiveContextProvider>
  );
}
